import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import { useConsultModel } from '../../hooks';
import { StaffInfo } from '../../const';
import styles from './style/index.less';
import { formateImageWebp } from '../../utils';
export var ServerMsgContainer = function (props) {
    var children = props.children, _a = props.maxWidth, maxWidth = _a === void 0 ? false : _a, _b = props.id, id = _b === void 0 ? '' : _b;
    var consultConfig = useConsultModel().getConsultConfig();
    var _c = useComponents(), View = _c.View, Image = _c.Image;
    var getAvatar = function () {
        var defaultAvatar = '//leads.gdtimg.com/qzone/biz/gdt/fmc_consult/images/chart_server.svg';
        // eslint-disable-next-line @typescript-eslint/naming-convention
        var hospital_config = consultConfig.hospital_config, staff_img_url = consultConfig.staff_img_url;
        if (hospital_config) {
            return hospital_config.logo || defaultAvatar;
        }
        if (!staffName) {
            return defaultAvatar;
        }
        return staff_img_url || defaultAvatar;
    };
    var getName = function () {
        if (consultConfig.enable_staff_info_show === StaffInfo.show) {
            return consultConfig.staff_name;
        }
        return '';
    };
    var staffName = getName();
    return (React.createElement(View, { id: id },
        React.createElement(View, { className: styles['server-msg'] },
            React.createElement(Image, { className: styles['server-msg-avatar'], src: formateImageWebp(getAvatar()), imageHeight: 37, imageWidth: 37 }),
            React.createElement(View, { className: styles['server-msg-content'] + " " + (maxWidth && styles['server-msg-width-max']) },
                staffName && React.createElement(View, { className: styles['server-name'] }, staffName),
                React.createElement(View, { className: styles['server-msg-detail'] },
                    React.createElement(View, { className: styles['server-msg-content-tail'] + " " + (staffName ? styles['with-name-tail'] : '') }),
                    children)))));
};
